import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AzureDataLakeStoreCosmosStructuredStreamLinkedService } from '../../linkedservice/azure-data-lake-store-cosmos-structured-stream.linkedservice';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { secretBaseToPasswordOrAKV, passwordOrAKVtoSecretBase } from './azure-key-vault.util';
import { ReferenceAdapter } from '../reference.adapter';
import { Credential } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreCosmosStructuredStreamLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                tenant: '*',
                accountName: '*',
                subscriptionId: '*',
                resourceGroupName: '*',
                encryptedCredential: '*',
                credential: '*'
            }
        }
    }
})
export class AzureDataLakeStoreCosmosStructuredStreamLinkedServiceAdapter extends LinkedServiceAdapter<AzureDataLakeStoreCosmosStructuredStreamLinkedService> {
    protected modelConstructor(): new () => AzureDataLakeStoreCosmosStructuredStreamLinkedService {
        return AzureDataLakeStoreCosmosStructuredStreamLinkedService;
    }

    protected model(): IModel {
        return AzureDataLakeStoreCosmosStructuredStreamLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureDataLakeStoreCosmosStructuredStreamLinkedService, linkedServiceResource: Model.LinkedServiceResource):
        Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureDataLakeStoreCosmosStructuredStreamLinkedService;

        properties.type = Metamodel.modelFor(AzureDataLakeStoreCosmosStructuredStreamLinkedService).name;

        let servicePrincipalId: string;
        let servicePrincipalKey: Model.SecretBase;
        let credential: Model.CredentialReference;
        if (linkedService.authenticationType === AuthenticationType.ServicePrincipal) {
            servicePrincipalId = linkedService.servicePrincipalId;
            servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
        } else if (linkedService.authenticationType === AuthenticationType.Credential) {
            credential = linkedService.credential ? ReferenceAdapter.toResource(linkedService.credential, this.context) as Model.CredentialReference : undefined;
        }
        properties.typeProperties = {
            accountName: linkedService.accountName,
            servicePrincipalId,
            servicePrincipalKey,
            tenant: linkedService.tenant,
            subscriptionId: linkedService.subscriptionId,
            resourceGroupName: linkedService.resourceGroupName,
            credential
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureDataLakeStoreCosmosStructuredStreamLinkedService):
        Promise<AzureDataLakeStoreCosmosStructuredStreamLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureDataLakeStoreCosmosStructuredStreamLinkedService;
        linkedService.accountName = properties.typeProperties.accountName;
        linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, properties.typeProperties.servicePrincipalId, this.context);
        if (properties.typeProperties.servicePrincipalId) {
            linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
            linkedService.authenticationType = AuthenticationType.ServicePrincipal;
        } else if (properties.typeProperties.credential) {
            linkedService.credential = ReferenceAdapter.toProxyModel(Metamodel.modelFor(Credential), properties.typeProperties.credential, this.context);
            linkedService.authenticationType = AuthenticationType.Credential;
        } else {
            linkedService.authenticationType = AuthenticationType.ManagedServiceIdentity;
        }
        linkedService.tenant = properties.typeProperties.tenant;
        linkedService.subscriptionId = properties.typeProperties.subscriptionId;
        linkedService.resourceGroupName = properties.typeProperties.resourceGroupName;
        return linkedService;
    }
}
